import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { Box, Grid } from '@mui/material';
import { uniqueId } from 'lodash';
import {
  ConneqtStatus,
  ViewConneqtPayload,
} from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { di } from '../../../state/inversify.config';
import { LoginDomainService } from '../../login/loginDomainService';
import { ConneqtSubRoutes } from '../conneqtSubRoutes';
import { ConneqtNewPlayerDomain } from './conneqtNewPlayer.domain';
import { ConneqtPageQueryService } from '../conneqt.queryParam.service';
import { ReceivedConneqtDomain } from './receivedConneqts.domain';
import { UserNotificationContext } from '../../../components/userNotification/userNotificationContext';
import { UserNotificationType } from '../../../components/userNotification/userNotificationType.enum';
import { Button } from '../../../components/button/button';
import { SelectInput } from '../../../components/select/selectInput';

interface ReceivedRequestsProps {
  conneqt: ViewConneqtPayload;
  setShowAddPlayerModal: (value: boolean) => void;
}
export function ResponsePlayer({
  conneqt,
  setShowAddPlayerModal,
}: ReceivedRequestsProps) {
  const navigator = useNavigate();
  const { addUserNotification } = useContext(UserNotificationContext);

  const createPlayerLabel = t('CREATE_NEW_PLAYER');

  const [selectedPlayer, setSelectedPlayer] = useState('');

  const conneqtPageQueryService = di.get(ConneqtPageQueryService);
  const { selectedConneqtId } = conneqtPageQueryService.useSelectMergedQuery();

  const receivedConneqtDomain = di.get(ReceivedConneqtDomain);
  const playerOptions = receivedConneqtDomain.usePlayerOptionsSelector();
  const playerOptionsWithCreatePlayerLabel = [
    { text: createPlayerLabel, value: createPlayerLabel },
  ].concat(playerOptions);
  const conneqtNewPlayerDomain = di.get(ConneqtNewPlayerDomain);

  const loginDomainService = di.get(LoginDomainService);
  const isNetworkConnected = loginDomainService.useNetworkSelector();

  const dispatchConneqtPlayer = (conneqtId: string, playerId: string) => {
    conneqtPageQueryService.dispatchQueryParams({
      selectedConneqtId: conneqtId,
    });

    receivedConneqtDomain.dispatchConneqtPlayer(conneqtId, playerId);

    navigator(
      `../${ConneqtSubRoutes.all}?selectedConneqtId=${selectedConneqtId}`,
    );
  };

  return (
    <Box sx={{ m: 1 }}>
      {conneqt.status === ConneqtStatus.Pending && isNetworkConnected && (
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={12} md={12}>
            <SelectInput
              id={uniqueId()}
              label={t('SELECT_PLAYER')}
              value={selectedPlayer}
              aria-label={t('accessibility.PLAYER_SELECT')}
              name="player-select"
              tabIndex={0}
              items={playerOptionsWithCreatePlayerLabel}
              onChange={(e: any) => {
                if (createPlayerLabel === e.target.value) {
                  conneqtNewPlayerDomain.dispatchPlayerCreationPending(conneqt);
                  setShowAddPlayerModal(true);
                } else {
                  setSelectedPlayer(e.target.value);
                }
              }}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              color="secondary"
              type="submit"
              variant="contained"
              testId="approve"
              fullWidth
              onClick={() => {
                if (selectedPlayer !== '') {
                  dispatchConneqtPlayer(conneqt.id, selectedPlayer);
                } else {
                  addUserNotification(
                    UserNotificationType.ERROR,
                    t('PLEASE_SELECT_PLAYER').toString(),
                    UserNotificationType.ERROR,
                  );
                }
              }}
              label={t('APPROVE')}
            />
          </Grid>
          <Grid item xs={6}>
            {isNetworkConnected && (
              <Button
                color="secondary"
                testId="reject"
                type="submit"
                variant="contained"
                fullWidth
                onClick={() =>
                  receivedConneqtDomain.dispatchRejectedStatus(conneqt.id)
                }
                label={t('REJECT')}
              />
            )}
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
